// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2yOzL","title":"ClientCherryInfo_title__1d-Ml","itemText":"ClientCherryInfo_itemText__1np-U"};